(function () {
  'use strict';

  var isProcessing = false;
  var pendingRemovalKey = null;
  var giftAddedVariantId = null;
  var isEnforcingQuantity = false;

  function formatMoney(cents) {
    var format = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
    format = format.replace(/<[^>]*>/g, '');
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format
      .replace('{{amount_with_comma_separator}}', dollars.replace(',', '.') + ',' + parts[1])
      .replace('{{amount_no_decimals_with_comma_separator}}', dollars.replace(',', '.'))
      .replace('{{amount_no_decimals}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount}}', dollars + '.' + parts[1]);
  }

  function checkCartForGift() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to fetch cart');
        return response.json();
      })
      .then(function (cart) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.properties && item.properties._gift_with_purchase === 'true') {
            return item;
          }
        }
        return null;
      });
  }

  function enforceGiftQuantity(item) {
    if (!item || item.quantity <= 1) return Promise.resolve();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to enforce gift quantity');
        return response.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      });
  }

  function getGwpProductId() {
    if (window.themeGiftConfig && window.themeGiftConfig.gwpProductId) {
      return String(window.themeGiftConfig.gwpProductId);
    }
    var source = document.querySelector('[data-gwp]');
    if (!source) return null;
    var raw = source.dataset.gwpGiftProductId;
    return raw ? String(raw) : null;
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Failed to change cart line');
      return response.json();
    });
  }

  // Capa 2: Listener global - corrige qty > 1 sin importar la fuente, y capa la
  // cantidad TOTAL del producto de regalo en 1 (cubre "agregó más del $0 desde su PDP").
  function globalGiftEnforcement() {
    if (isEnforcingQuantity) return;
    isEnforcingQuantity = true;
    fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to fetch cart');
        return response.json();
      })
      .then(function (cart) {
        var pid = getGwpProductId();
        if (!pid) {
          // Fallback: comportamiento legacy (solo corrige la línea con la propiedad).
          for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            if (it.properties && it.properties._gift_with_purchase === 'true' && it.quantity > 1) {
              return enforceGiftQuantity(it);
            }
          }
          return;
        }
        var lines = cart.items.filter(function (it) { return String(it.product_id) === pid; });
        if (!lines.length) return;
        var total = lines.reduce(function (sum, it) { return sum + it.quantity; }, 0);
        if (lines.length === 1 && total <= 1) return;

        // Conserva una sola unidad, prefiriendo la línea con la propiedad _gift_with_purchase.
        var keeper = null;
        for (var j = 0; j < lines.length; j++) {
          if (lines[j].properties && lines[j].properties._gift_with_purchase === 'true') { keeper = lines[j]; break; }
        }
        if (!keeper) keeper = lines[0];

        var changes = [];
        lines.forEach(function (it) {
          if (it.key === keeper.key) {
            if (it.quantity !== 1) changes.push({ key: it.key, quantity: 1 });
          } else {
            changes.push({ key: it.key, quantity: 0 });
          }
        });
        if (!changes.length) return;
        return changes.reduce(function (p, ch) {
          return p.then(function () { return changeLine(ch.key, ch.quantity); });
        }, Promise.resolve()).then(function () {
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        });
      })
      .catch(function (err) { console.error('GWP: enforce error', err); })
      .finally(function () { isEnforcingQuantity = false; });
  }

  document.addEventListener('cart:updated', globalGiftEnforcement);
  document.addEventListener('quick-cart:updated', globalGiftEnforcement);

  function initGWP(container) {
    if (!container) return;

    var threshold = parseFloat(container.dataset.gwpThreshold) * 100;
    var cartTotal = parseInt(container.dataset.gwpCartTotal, 10);
    var giftInCart = container.dataset.gwpGiftInCart === 'true';
    var giftLineItemKey = container.dataset.gwpGiftLineItemKey;
    var staleGiftInCart = container.dataset.gwpStaleGiftInCart === 'true';
    var staleGiftLineItemKey = container.dataset.gwpStaleGiftLineItemKey;
    var productTitle = container.dataset.gwpProductTitle || '';
    var pendingMessage = container.dataset.gwpPendingMessage.replace('{{ product_name }}', productTitle);
    var eligibleMessage = container.dataset.gwpEligibleMessage.replace('{{ product_name }}', productTitle);
    var addedMessage = container.dataset.gwpAddedMessage.replace('{{ product_name }}', productTitle);

    var messageEl = container.querySelector('.gwp-bar__message');
    var progressFill = container.querySelector('.gwp-bar__progress-fill');
    var progressBar = container.querySelector('.gwp-bar__progress');
    var colorPicker = container.querySelector('[data-gwp-color-picker]');

    if (!messageEl) return;

    // Auto-remove stale gift from old product before processing normal state
    if (staleGiftInCart && staleGiftLineItemKey) {
      removeGiftFromCart(staleGiftLineItemKey);
      return;
    }

    if (cartTotal < threshold) {
      // Below threshold
      var remaining = threshold - cartTotal;
      var percent = Math.min((cartTotal / threshold) * 100, 100);
      var message = pendingMessage.replace('{{ remaining_amount }}', formatMoney(remaining));

      messageEl.innerHTML = message;
      if (progressFill) progressFill.style.width = percent + '%';
      if (progressBar) progressBar.style.display = '';
      if (colorPicker) colorPicker.style.display = 'none';

      container.classList.remove('gwp-bar--eligible', 'gwp-bar--added');
      container.classList.add('gwp-bar--pending');

      // Auto-remove gift if cart drops below threshold
      if (giftInCart && giftLineItemKey) {
        removeGiftFromCart(giftLineItemKey);
      }
    } else if (!giftInCart) {
      // Eligible but no gift yet. If we previously tracked an add via giftAddedVariantId
      // but the fresh render says the gift is gone (e.g. via /cart route or external
      // mutation), clear the guard so the eligible state renders instead of leaving a
      // blank bar.
      if (giftAddedVariantId) giftAddedVariantId = null;

      var autoAdd = container.dataset.gwpAutoAdd === 'true';
      var autoAddVariantId = container.dataset.gwpAutoAddVariantId;

      if (autoAdd && autoAddVariantId) {
        // Product has no variants — auto-add immediately
        messageEl.innerHTML = addedMessage;
        if (progressBar) progressBar.style.display = 'none';
        if (colorPicker) colorPicker.style.display = 'none';
        container.classList.remove('gwp-bar--pending', 'gwp-bar--eligible');
        container.classList.add('gwp-bar--added');
        autoAddGift(autoAddVariantId);
        return;
      }

      messageEl.innerHTML = eligibleMessage;
      if (progressFill) progressFill.style.width = '100%';
      if (progressBar) progressBar.style.display = 'none';
      if (colorPicker) colorPicker.style.display = '';

      container.classList.remove('gwp-bar--pending', 'gwp-bar--added');
      container.classList.add('gwp-bar--eligible');

      bindSwatches(container);
    } else {
      // Gift already in cart
      messageEl.innerHTML = addedMessage;
      if (progressFill) progressFill.style.width = '100%';
      if (progressBar) progressBar.style.display = 'none';
      if (colorPicker) colorPicker.style.display = 'none';

      container.classList.remove('gwp-bar--pending', 'gwp-bar--eligible');
      container.classList.add('gwp-bar--added');
    }
  }

  function bindSwatches(container) {
    var swatches = container.querySelectorAll('.gwp-bar__swatch');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (isProcessing) return;
        var variantId = swatch.dataset.gwpVariantId;
        addGiftToCart(variantId, container, swatch);
      });
    });
  }

  function addGiftToCart(variantId, container, swatch) {
    if (isProcessing) return;
    isProcessing = true;
    pendingRemovalKey = null;

    // Visual feedback
    var swatches = container.querySelectorAll('.gwp-bar__swatch');
    swatches.forEach(function (s) {
      s.classList.remove('gwp-bar__swatch--selected');
      s.disabled = true;
    });
    swatch.classList.add('gwp-bar__swatch--selected');

    checkCartForGift()
      .then(function (existingGift) {
        if (existingGift) {
          // Regalo ya existe, solo corregir qty si necesario
          giftAddedVariantId = existingGift.variant_id;
          return enforceGiftQuantity(existingGift);
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId, 10),
              quantity: 1,
              properties: {
                _gift_with_purchase: 'true'
              }
            }]
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to add gift');
            return response.json();
          })
          .then(function (data) {
            giftAddedVariantId = parseInt(variantId, 10);
            document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
            // Post-add safety: corregir qty si > 1
            if (data.items && data.items.length > 0 && data.items[0].quantity > 1) {
              return enforceGiftQuantity(data.items[0]);
            }
          });
      })
      .catch(function (err) {
        console.error('GWP: Error adding gift', err);
        swatches.forEach(function (s) {
          s.disabled = false;
        });
        swatch.classList.remove('gwp-bar__swatch--selected');
      })
      .finally(function () {
        isProcessing = false;
        processPendingRemoval();
      });
  }

  function autoAddGift(variantId) {
    if (isProcessing) return;

    // Bail-out: ya agregamos un regalo esta sesión
    if (giftAddedVariantId) return;

    isProcessing = true;
    pendingRemovalKey = null;

    checkCartForGift()
      .then(function (existingGift) {
        if (existingGift) {
          // Regalo ya existe, solo corregir qty si necesario
          giftAddedVariantId = existingGift.variant_id;
          return enforceGiftQuantity(existingGift);
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { _gift_with_purchase: 'true' } }]
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to add gift');
            return response.json();
          })
          .then(function (data) {
            giftAddedVariantId = parseInt(variantId, 10);
            document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
            // Post-add safety: corregir qty si > 1
            if (data.items && data.items.length > 0 && data.items[0].quantity > 1) {
              return enforceGiftQuantity(data.items[0]);
            }
          });
      })
      .catch(function (err) {
        console.error('GWP: Error auto-adding gift', err);
      })
      .finally(function () {
        isProcessing = false;
        processPendingRemoval();
      });
  }

  function processPendingRemoval() {
    if (pendingRemovalKey) {
      var key = pendingRemovalKey;
      pendingRemovalKey = null;
      removeGiftFromCart(key);
    }
  }

  function removeGiftFromCart(lineItemKey) {
    if (isProcessing) {
      pendingRemovalKey = lineItemKey;
      return;
    }
    isProcessing = true;
    pendingRemovalKey = null;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: 0
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to remove gift');
        return response.json();
      })
      .then(function () {
        giftAddedVariantId = null;
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      })
      .catch(function (err) {
        console.error('GWP: Error removing gift', err);
      })
      .finally(function () {
        isProcessing = false;
        processPendingRemoval();
      });
  }

  function initAll() {
    var containers = document.querySelectorAll('[data-gwp]');
    containers.forEach(initGWP);
  }

  var initScheduled = false;
  function scheduleInit() {
    if (initScheduled) return;
    initScheduled = true;
    requestAnimationFrame(function () {
      initScheduled = false;
      initAll();
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // MutationObserver on .quick-cart (always exists) instead of .quick-cart__items
  // (which only exists when cart has items). This ensures we catch the first product add.
  var observeTarget = document.querySelector('.quick-cart');
  var observer = null;

  function startObserver() {
    if (!observeTarget || observer) return;
    observer = new MutationObserver(function () {
      // Disconnect before running to prevent infinite loop
      stopObserver();
      scheduleInit();
      // Reconnect after a tick so our own DOM changes don't re-trigger
      setTimeout(startObserver, 0);
    });
    observer.observe(observeTarget, { childList: true, subtree: true });
  }

  function stopObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  startObserver();

  // Also listen for quick-cart section re-renders
  document.addEventListener('quick-cart:updated', function () {
    stopObserver();
    scheduleInit();
    setTimeout(startObserver, 0);
  });
})();
